import { ProductEdited, ProductType } from '../models';
import { LearnizModel } from './learniz';

export class LearnizEdited implements ProductEdited<LearnizModel> {
  slug: string; // productSlug (during edition, there is no perimeter)
  name: string;
  data: LearnizModel;
  updatedAt?: Date;
  documents?: string[]; //used on send
  visible?: boolean;
  active?: boolean;
  publishedAt?: Date;
  productType?: ProductType;
  shareInProgress?: boolean;
  folderProduct?: {
    slug: string;
  };
  hasConfigDraft?: boolean;

  constructor(edited?: LearnizEdited) {
    this.slug = edited?.slug;
    this.name = edited?.name;
    this.data = edited?.data ? new LearnizModel(edited.data) : new LearnizModel();
    this.updatedAt = edited?.updatedAt ? new Date(edited.updatedAt) : null;
    this.publishedAt = edited?.publishedAt ? new Date(edited.publishedAt) : null;
    this.productType = ProductType.LEARNIZ;
    this.shareInProgress = edited?.shareInProgress ?? false;
    this.folderProduct = edited?.folderProduct;
    this.hasConfigDraft = edited?.hasConfigDraft ?? false;
  }
}
